import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { Button } from '../../../CommonComponents/OPL/Button/Button';
import { WidgetSlugDTO } from '../../api/useDefaultTemplateQuery';

interface Props {
  activeTab: WidgetSlugDTO;
  onOpen: () => void;
}

export const AddWidgets = ({ activeTab, onOpen }: Props) => {
  const { watch } = useFormContext();

  const widgets = watch('widgets')?.[activeTab];

  if (
    (widgets.included.length === 0 && widgets.excluded.length === 0) ||
    widgets.excluded.length === 0
  ) {
    return null;
  }

  return (
    <Box display="flex" justifyContent="flex-end">
      <Button variant="subtleActive" leftIcon="fas fa-plus" onClick={() => onOpen()}>
        Add Card
      </Button>
    </Box>
  );
};
